import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionLabel } from './SectionLabel';

const FAQS = [
  {
    q: 'Quanto custa?',
    a: 'Zero. É grátis pra usar. A gente só pede um e-mail pra você não perder seu progresso entre dispositivos.',
  },
  {
    q: 'Funciona no celular?',
    a: 'Sim, e foi pensado para usar nele. Ícones grandes, toque rápido pra marcar figurinha e muito mais!',
  },
  {
    q: 'Posso compartilhar minha lista no WhatsApp?',
    a: 'Pode. Tem um botão "Copiar pro WhatsApp" que gera um texto formatadinho com suas repetidas e faltantes.',
  },
  {
    q: 'Quantas figurinhas tem o álbum?',
    a: '980 no total, 48 seleções com 20 figurinhas cada (1 escudo + 19 jogadores) e mais 20 especiais sobre a Copa (logo, bolas, países-sede e história do mundial). Fora da contagem, ainda tem as 14 colecionáveis Coca-Cola e 4 extras (regular, bronze, prata e ouro).',
  },
  {
    q: 'Os meus amigos precisam ter conta?',
    a: 'Pra acompanhar a coleção dele e o app cruzar repetidas e faltantes automaticamente, sim. É só enviar o link de convite que aparece na aba Amigos. Mas tem outras formas: dá pra colar a lista de repetidas que ele te mandar no WhatsApp na aba Trocas, ou, se estiverem juntos, usar o QR Code. Um mostra, o outro escaneia e o app diz na hora o que cada um precisa do outro, sem precisar de conta.',
  },
];

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-ink-300 last:border-b-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-4 py-5 text-left bg-transparent border-none cursor-pointer btn-focus"
      >
        <span className="font-display font-semibold text-[17px] text-ink-900">{q}</span>
        <ChevronDown
          size={20}
          className={[
            'text-ink-500 shrink-0 transition-transform duration-base',
            open ? 'rotate-180' : 'rotate-0',
          ].join(' ')}
        />
      </button>
      {open && (
        <p className="font-body text-body text-ink-700 leading-relaxed pb-5 -mt-1 max-w-2xl">
          {a}
        </p>
      )}
    </div>
  );
}

export function FAQBlock() {
  return (
    <section className="py-16 md:py-24 bg-paper">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <div className="max-w-md mb-10">
          <SectionLabel tone="green">Perguntas</SectionLabel>
          <h2 className="font-display font-bold text-h1 md:text-[36px] leading-tight text-ink-900 mt-3">
            Dúvidas sobre o BoraTrocar:
          </h2>
        </div>
        <div className="max-w-3xl">
          {FAQS.map((f) => (
            <FAQItem key={f.q} q={f.q} a={f.a} />
          ))}
        </div>
      </div>
    </section>
  );
}
